// extracted by mini-css-extract-plugin
export var divider = "_r2-0";
export var systemMessage = "_r2-1";